import React from "react";
import Count from "shared/components/counts/Count.js";
import "./MiscArenaManagerStats.css";

const MiscArenaManagerStats = ({ manager }) => {
  const ladderStats = [
    ["AP", manager.ladder?.ap],
    ["Global rank", manager.ladder?.rank],
    ["Starting XI OVR", manager.squad?.xiOvr],
  ];
  const careerStats = [
    ["Wins", manager.career?.wins],
    ["Draws", manager.career?.draws],
    ["Losses", manager.career?.losses],
    ["Matches played", manager.career?.matchesPlayed],
    ["Best streak", manager.career?.bestStreak],
  ];

  return (
    <div className="MiscArenaManagerStats background-color rounded" role="region" aria-label="Arena statistics" tabIndex={0}>
      {[...ladderStats, ...careerStats].map(([label, value], index) => (
        <div
          className={"MiscArenaManagerStats-stat" + (index === ladderStats.length ? " MiscArenaManagerStats-divider" : "")}
          key={label}
        >
          <Count label={label} count={value ?? "—"} />
        </div>
      ))}
    </div>
  );
};

export default MiscArenaManagerStats;
